import { GetterTree } from 'vuex';
import { CateringPackage, CateringRecommendationRequest } from '@/types/cateringBot';
import { state as rallyIntelligenceState } from '../rallyIntelligence/rallyIntelligence';
import { CateringBotState, RootState } from '../types';

export const getters: GetterTree<CateringBotState, RootState> = {
	isEnabled(state): boolean {
		return state.enabled;
	},
	lastInput(state): CateringRecommendationRequest | null {
		return state.lastInput;
	},
	refiningIndex(state): number | null {
		return state.refiningIndex;
	},
	canRefine(state): boolean {
		return rallyIntelligenceState.creditsRemaining > 0 && state.refiningIndex === null;
	},
	packagesToRender(state): CateringPackage[] {
		return state.lastResults ?? [];
	}
};
